import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { toast } from 'react-toastify'

export const getConfiguration = createAsyncThunk('configuration/getConfiguration', async () => {
  try {
    let url = '/configration'
    const response = await apiClient.get(url)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})

export const editConfiguration = createAsyncThunk('configuration/editConfiguration', async (editObj, { dispatch }) => {
  try {
    const url = `/configration`
    const response = await apiClient.post(url, editObj)
    dispatch(getConfiguration())
    if (response.status) {
      toast.success(response.data.message, {
        className: 'custom-toast-success',
        progressStyle: { background: '#ffffff' },
      })
    }
    return response.editObj
  } catch (error) {
    // console.error('builder function error:', error)
    toast.error(error.response.data.message, {
      className: 'custom-toast-error',
      progressStyle: { background: '#C53C43' },
    })
    throw error
  }
})
